import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class PostInterceptorService {
	private btSalvarStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
		true
	);

	constructor() {}

	getBtSalvarStatus() {
		return this.btSalvarStatus.asObservable();
	}

	setBtSalvarStatus(status: boolean) {
		this.btSalvarStatus.next(status);
	}
}
